var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"echarts",attrs:{"id":"bar-chart"}},[_c('VueApexCharts',{attrs:{"type":"bar","options":_vm.options,"series":_vm.series,"height":_vm.height}}),(_vm.args.graphTitle != null)?_c('h3',[_vm._v(_vm._s(_vm.args.graphTitle))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }